// PHASE Hotspot Grid: hotspot pop-ups + AJAX add to cart, falling back to the native form post.

class PhaseHotspot extends HTMLElement {
  connectedCallback() {
    this.dot = this.querySelector('.phase-hsg__dot');
    this.dialog = this.querySelector('dialog');
    if (!this.dot || !this.dialog) return;

    this.dot.addEventListener('click', () => (this.dialog.open ? this.close(true) : this.open(true)));
    this.dialog.querySelector('[data-close]')?.addEventListener('click', () => this.close(true));
    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); this.close(true); }
    });
    this.dialog.addEventListener('close', () => this.dot.setAttribute('aria-expanded', 'false'));

    // Click/tap/Enter/Space only (native <button>). Close on outside click or Escape.
    document.addEventListener('click', (e) => {
      if (this.dialog.open && !this.dialog.contains(e.target) && !this.dot.contains(e.target)) this.close(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.dialog.open) { e.preventDefault(); this.close(true); }
    });

    const select = this.dialog.querySelector('select[name="id"]');
    const price = this.dialog.querySelector('[data-price]');
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      if (opt && price) price.textContent = opt.dataset.price;
    });

    const form = this.dialog.querySelector('form[data-hsg-form]');
    form?.addEventListener('submit', (e) => this.addToCart(e, form));
  }

  open(moveFocus) {
    document.querySelectorAll('phase-hotspot').forEach((el) => el !== this && el.close?.(false));
    if (!this.dialog.open) this.dialog.show(); // non-modal so the page stays usable
    this.dot.setAttribute('aria-expanded', 'true');
    if (moveFocus) this.dialog.querySelector('select, button[type="submit"], a')?.focus();
  }

  close(returnFocus) {
    if (this.dialog?.open) this.dialog.close();
    this.dot?.setAttribute('aria-expanded', 'false');
    if (returnFocus) this.dot?.focus();
  }

  async addToCart(e, form) {
    if (!window.fetch) return; // native POST fallback
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const status = form.querySelector('.phase-hsg__status');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      status.textContent = 'Added to cart';
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: data, sourceId: this.id, data: { source: 'phase-hotspot-grid' } } }));
      this.refreshCartUI();
    } catch (err) {
      // If AJAX is unavailable/blocked, fall back to the classic form post.
      if (err instanceof TypeError) { form.submit(); return; }
      status.textContent = err.message;
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  async refreshCartUI() {
    // Refresh Horizon's cart count; open the drawer if present, otherwise offer the cart page.
    try {
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      document.querySelectorAll('cart-icon, .cart-bubble__text-count').forEach((el) => {
        if (el.classList.contains('cart-bubble__text-count')) el.textContent = cart.item_count;
      });
    } catch (_) { /* non-blocking */ }
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { this.close(false); drawer.open(); }
  }
}

if (!customElements.get('phase-hotspot')) customElements.define('phase-hotspot', PhaseHotspot);
